import { render, staticRenderFns } from "./WS-SignUpAgree.vue?vue&type=template&id=1794fa30"
import script from "./WS-SignUpAgree.vue?vue&type=script&lang=js"
export * from "./WS-SignUpAgree.vue?vue&type=script&lang=js"
import style0 from "./WS-SignUpAgree.vue?vue&type=style&index=0&id=1794fa30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports